var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "cityId", $$v);
      },
      expression: "searchForm.cityId"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chCityName,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "标题"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "title", $$v);
      },
      expression: "searchForm.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userName", $$v);
      },
      expression: "searchForm.userName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "分类"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.categoryId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v);
      },
      expression: "searchForm.categoryId"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chName,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "物品状态"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "未审核",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "审核通过",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "审核失败",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "是否开放"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.goodsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "goodsStatus", $$v);
      },
      expression: "searchForm.goodsStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "已删除",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "关闭",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "开放",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "是否推荐"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.isRecommend,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "isRecommend", $$v);
      },
      expression: "searchForm.isRecommend"
    }
  }, [_c("el-option", {
    attrs: {
      label: "未推荐",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "已推荐",
      value: "1"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {};
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "编号",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-used-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.code
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "姓名",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.gender",
      label: "性别",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user.gender == "0" ? _c("span", [_vm._v("未知")]) : _vm._e(), scope.row.user.gender == "1" ? _c("span", [_vm._v("男")]) : _vm._e(), scope.row.user.gender == "2" ? _c("span", [_vm._v("女")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.phone",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "user.occupation",
      label: "职业",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "标题",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-used-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.title
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "adminUser.name",
      label: "审核人员"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "category",
      label: "种类",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "originalPrice",
      label: "原价",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "presentPrice",
      label: "现价",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "city",
      label: "城市",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "district",
      label: "区域",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "collectNum",
      label: "收藏数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lookNum",
      label: "浏览数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "2" ? _c("span", [_vm._v("审核失败")]) : _vm._e(), scope.row.status == "1" ? _c("span", [_vm._v("审核通过")]) : _vm._e(), scope.row.status == "0" ? _c("span", [_vm._v("未审核")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否推荐",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.isRecommend == "1" ? _c("span", [_vm._v("是")]) : _vm._e(), scope.row.isRecommend == "0" ? _c("span", [_vm._v("否")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否开放",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.goodsStatus == "1" ? _c("span", [_vm._v("未开放")]) : _vm._e(), scope.row.goodsStatus == "2" ? _c("span", [_vm._v("开放")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "创建时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "update",
      label: "更新时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "160",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.goodsStatus == "1" ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.operation(scope.row);
            }
          }
        }, [_vm._v("打 开")]) : _vm._e(), scope.row.goodsStatus == "2" ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.operation(scope.row);
            }
          }
        }, [_vm._v("关 闭")]) : _vm._e(), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编 辑")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.comment(scope.row);
            }
          }
        }, [_vm._v("评 论")]), scope.row.isRecommend == 0 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.recommend(scope.row);
            }
          }
        }, [_vm._v("推 荐")]) : _vm._e(), scope.row.isRecommend == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.recommend(scope.row);
            }
          }
        }, [_vm._v("取消推荐")]) : _vm._e(), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删 除")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };